<template>
  <div id="news" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_news"></div>
    <div class="container">
      <div class="block">
        <div class="news">
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-divider content-position="left" style="margin-bottom: 20px;"><i class="el-icon-s-operation" style="font-size: 22px;"><span
                    style="margin-left: 15px;">企校合作</span></i></el-divider>
              <template>
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column label="id" width="0">
                    <template slot-scope="scope">
                      <span>{{ scope.row.id }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="标题">
                    <template slot-scope="scope">
                      <i class="rudius"></i>
                      <el-link @click="toContent(scope.row.xvhao)" style="margin-left: 20px" target="_blank" :underline="false">{{ scope.row.title }}</el-link>
                      <div v-if="scope.row.file" style="cursor: pointer;" @click="toContent(scope.row.id,scope.row.weigh)">
                        <el-row :gutter="50" style="display: flex;align-items: center;">
                          <el-col :xs="5" :sm="5" :md="5" :lg="24" :xl="24">
                            <el-image :src="$http+scope.row.file" style="margin-top: 15px;width: 160px;"
                              fit="cover"></el-image>
                          </el-col>
                          <el-col :xs="19" :sm="19" :md="19" :lg="24" :xl="24">
                            <div v-html="scope.row.content" class="news_content">{{scope.row.content}}</div>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="100">
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <el-pagination style="margin: 50px 0;" :current-page="currentPage" background @current-change="handleCurrentChange"
                layout="prev, pager, next" :total="total">
              </el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'news',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        currentPage: 1,
        activeName: 'first',
        tableData: [],
        imageData: [],
        total: 0
      };
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      this.loadImage();
      this.currentPage = 1;
      this.qryTableData();
    },
    methods: {
      handleClick(tab, event) {},
      loadImage() {
        this.axios.get(process.env.API_ROOT + "/admin/news/getImagetext")
          .then((res) => {
            this.imageData = [];
            for (var i = 0; i < 5; i++) {
              this.imageData.push({
                src: res.data.data[i].image,
                title: res.data.data[i].title,
                time: res.data.data[i].time,
                id: res.data.data[i].id,
                xvhao: res.data.data[i].xvhao
              });
            }
          })
          .catch((err) => {})
      },
      toContent: function(mallCode) {
        this.$router.push({
          path: '/content',
          // name: 'mallList',
          query: {
            number: mallCode,
            type: 1
          }
        })
      },
      setContextData: function(key, value) {
        if (typeof value == "string") {
          sessionStorage.setItem(key, value);
        } else {
          sessionStorage.setItem(key, JSON.stringify(value));
        }
      },
      getContextData: function(key) {
        const str = sessionStorage.getItem(key);
        if (typeof str == "string") {
          try {
            return JSON.parse(str);
          } catch (e) {
            return str;
          }
        }
        return;
      },
      qryTableData() {
        this.axios.get(process.env.API_ROOT + "/admin/news/cooperList", {
            params: {
              page: this.currentPage
            }
          })
          .then((res) => {
            this.tableData = [];
            this.total = [];
            this.total = res.data.count;
            for (var i = 0; i < res.data.data.length; i++) {
              this.tableData.push({
                src: res.data.data[i].image,
                title: res.data.data[i].title,
                introduction: res.data.data[i].introduction,
                time: res.data.data[i].time,
                id: res.data.data[i].id,
                xvhao: res.data.data[i].xvhao
              });
            }
          })
          .catch((err) => {})
      },
      handleCurrentChange: function(currentPage) {
        this.currentPage = currentPage;
        this.setContextData("currentPage", this.currentPage);
        this.qryTableData();
      },
    }
  }
</script>

<style>
  #news .cell img {
    /* width: 100%;
    max-height: 100px; */
  }

  .news_content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_cooper.vue